<template>
  <div class="alert-container">
    <div v-for="error in errors" :key="error.id" class="alert-box" :class="{ success: error.type === 'success', faild: error.type === 'faild' }">
      {{ error.message }}
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();

    // Use Composition API to access the errors from the Vuex store
    const errors = computed(() => store.getters["error/GET_ERRORS"]);
    
    return {
      errors,
    };
  },
};
</script>

<style scoped>
.alert-container {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: 0.3s ease-in-out;
}

.alert-box {
  
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease-in-out;
}

.faild { 
  background-color: #ff1d30d3;
  color: #ffffff;
  border: solid 1px #ffb6b6d3 ;
}
.success{
  background-color: #008127da;
  color: #ffffff;
}
</style>
